import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isAdmin, isGuestOnly } from '../../types/auth';
import { isAllowedForGuest } from './guestRoutes';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Csak az admin nyithatja meg (pl. jelentkezések, iskolák, pályák kezelése). */
  adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // A vendégnek a többi oldal üres lapot adna (a szerver semmit nem ad vissza
  // rajtuk), ezért inkább a naptárra visszük - ott van dolga.
  if (isGuestOnly(user) && !isAllowedForGuest(location.pathname)) {
    return <Navigate to="/calendar" replace />;
  }

  // Régi linkről vagy könyvjelzőből érkező edző: a kezdőlapra visszük
  if (adminOnly && !isAdmin(user)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
